// extracted by mini-css-extract-plugin
export default {"container":"ModalOrderInfo_container__S6DVm","wrapperCard":"ModalOrderInfo_wrapperCard__k4Vqs"};